import {Pipe, PipeTransform} from '@angular/core';
import {Observable, of} from 'rxjs';
import {CruiseBookingService} from '../../booking-flow/cruise/cruise-booking-page/services/cruise-booking.service';
import {ICruiseDetailCabin} from '../../booking-flow/cruise/cruise-detail-page/interfaces/icruise-detail-cabin';

@Pipe({
  name: 'cabinDescriptionByFareString'
})
export class CabinDescriptionByFarePipeString implements PipeTransform {

  constructor(private _cruiseBookingService: CruiseBookingService) {
  }

  transform(value: string, tourOperatorId: number, type: string): Observable<{}> {
    if (value && tourOperatorId) {
      const cabinTmp: ICruiseDetailCabin = {
        availability: false,
        available: false,
        code: null,
        description: null,
        fare: value,
        fareName: null,
        fsb: null,
        id: null,
        price: null,
        type,
        taxes: null,
        isUpdatedFromCategory: null,
        categoryDescription: null
      };
      return this._cruiseBookingService.getFareInfo({cabin: cabinTmp, tourOperatorId});
    }
    return of(null);
  }

}
